<tiime-input-container tiimeFormInputContainer contentId="genericEmail" [label]="label" [required]="required">
  <tiime-select id="genericEmail" [class.selected]="genericEmailControl.value" [formControl]="genericEmailControl">
    <div tiimeSelectOptions>
      @for (genericEmail of genericEmails; track trackByIndex($index)) {
        <mat-option [value]="genericEmail">
          {{ genericEmail }}
        </mat-option>
      }
    </div>
  </tiime-select>
</tiime-input-container>
